import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TabPermissions, SupplierBankPropertyValue, SupplierEntityPropertyValues, SupplierDocumentPropertyValues, OPERATION, SupplierPropertyValue, Supplier, SupplierBank, SupplierDocument, DocumentTypeCategory, PropertyValue, Permission, SupplierProfileEvent, SupplierContactPropertyValue } from 'app/profile/models/supplier.model';
import { GetTabPermissions, GetSupplierBankListByCode, GetSupplierEntityListByCode, GetValidationTaskByCode, GetSupplierDocumentsListByCode, GetSupplierProfileCurrentUser, PostEvent, DeleteSupplierBank, GetSecurityEvent, ClearSupplierBanks, ClearEvent, GetSupplierContactListByCode, GetSupplierOtpRequestByUser,GetPreventativeInProgress } from 'app/profile/store/app.actions';
import { select, Store } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { SelectTabPermissions, SelectSupplierBankList, SelectSupplierEntityList, SelectValidationTask, SelectSupplierDocumentList, SelectCurrentUser, SelectEventData, SelectSecurityEventData, SelectSupplierContactList, SelectSupplierOtpRequest, SelectUserPendingTaskList ,SelectPreventativeInProgress} from 'app/profile/store/app.selector';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationTask } from 'app/profile/models/people.model';
import { deepfind, getNestedNode, Guid, showMFADialog } from 'app/shared/utils/utils';
import { UserDetails, SupplierContactMap } from 'app/profile/models/user.model';
import { TslDialog } from '@tesla/ng-tds';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'app/profile/services/common.service';
import { StateService } from 'app/profile/services/state.service';
import { BankDialogComponent } from './bank-dialog/bank-dialog.component';
import { BaseComponent } from '../../base.component';
import { takeUntil } from 'rxjs/operators';
import { SecurityCheckComponent } from './security-check/security-check.component';
import { LocalStorageService } from 'app/shared/services/index.service';
import { BANK_TOKEN, statusClass, statusDisplay } from 'app/shared/constants';
import { SelectErrorMessages, SelectErrorState } from 'app/shared/store/selectors';
import { TabHistoryComponent } from '../../tab-history/tab-history.component';
import { AuthData } from '@tesla/ng-auth';
import { I18nService } from '../../../../shared/services/i18n.service';
import { BankService } from 'app/profile/services/bank.service';
import { PayoutProps, VerifyAccountArgs } from '@tesla/payout-react';
import { PayoutAngularComponent } from '@tesla/payout-angular';
import * as BankDataActions from 'app/profile/store/actions/bank.actions';
import { AppSettings } from '../../../../app.settings';
import { isNullOrUndefined } from 'util';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';

@Component({
  selector: 'app-bank-grid',
  templateUrl: './bank-grid.component.html',
  styleUrls: ['./bank-grid.component.scss']
})
export class BankGridComponent extends BaseComponent implements OnInit {
  @Input() supplierCode: string;
  @Input() isDataUnderReview: boolean = false;
  @ViewChild('payoutRefAngular')
  payoutRefAngular: PayoutAngularComponent;
  payoutData: PayoutProps;

  tabPermissions: TabPermissions;
  bankInfo: SupplierBankPropertyValue[] = [];
  datasource: BehaviorSubject<Array<SupplierBankPropertyValue>> = new BehaviorSubject([]);

  displayedColumns = ['nickname', 'bankname', 'accountnumber', 'iban', 'verificationStatus', 'actions'];
  pageSizeOptions: number[] = [10, 25, 50, 100, 250];
  pageIndex = 0;
  popUpKey: string = "PCFPopUp";
  pageSize = 10;
  total = 0;
  primaryPendingForApproval: boolean = false;

  entityMap: SupplierEntityPropertyValues[];
  documentsList: SupplierDocumentPropertyValues[];
  bankModifiedSupplier: SupplierPropertyValue = new SupplierPropertyValue();
  validationTask: ValidationTask = null;
  isValidationTaskComplete: boolean = false;
  primaryEmail: string = null;
  isPrimary: boolean = false;
  userDetails: UserDetails = null;
  securityBreached: boolean = false;
  currentUserEmail: string;
  validationStatus: string = null;
  hasPendingValidationTask: boolean = false;
  isProfileLocked: boolean = true;
  userPendingTasks: SupplierTaskDetail[] = [];
  preventativeHold: boolean =false;
  supplierContacts: SupplierContactPropertyValue[] = [];

  // Messages
  isContactValidationPendingTaskErrorMessage: string = "No edit functionality available as your organization's contacts have yet to be validated, you are not enrolled in Multi-Factor Authentication, critical data changes are pending review, or you have no user access to manage this data.";

  // Status Display Variables
  statusClass = statusClass;
  statusDisplay = statusDisplay;

  get hasWriteAccess(): boolean {
    return this.userDetails
      && this.isValidationTaskComplete
      && this.tabPermissions
      && this.tabPermissions.bank === Permission.ReadWrite
      && (this.userPendingTasks == null || this.userPendingTasks.length == 0 || this.userPendingTasks?.filter(x => x.subTaskType == "MFAEnrollment")?.length == 0)
      && (this.isPCFUploaded || this.showMFADialog);
  }

  get hasWriteAccessForValidationTask(): boolean {
    return this.userDetails
      && this.validationTask?.statusId !== 3
      && this.tabPermissions
      && this.tabPermissions.bank === Permission.ReadWrite
      && this.isPCFUploaded;
  }

  get hasEditPermissions(): boolean {
    return this.tabPermissions && this.tabPermissions.bank === Permission.ReadWrite;
  }

  get isLocked(): boolean {
    return this.securityBreached;
  }

  constructor(private matDialog: MatDialog,
    private store: Store<SupplierState>,
    private dialog: TslDialog,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private stateService: StateService,
    private config: AppSettings,
    private snackBar: MatSnackBar,
    public translateService: I18nService,
    private authData: AuthData,
    private storageService: LocalStorageService,
    private bankService: BankService) {
    super();
    this.payoutData = {
      environment: this.config.Production ? 'prod' : 'stage'
    }
    this.currentUserEmail = authData.getUserInfo().email;
  }

  ngOnInit() {
    this.store.dispatch(new GetSupplierProfileCurrentUser());
    this.store.dispatch(BankDataActions.GetBankCountries({ supplierCode: this.supplierCode }));
    this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, false));
    this.store.pipe(select(SelectUserPendingTaskList)).subscribe(x => {
      if(x){
        this.userPendingTasks = x;
      }
    });
    this.store.pipe(select(SelectSupplierContactList)).subscribe(contacts => {
      if (contacts) {
        this.supplierContacts = contacts;
        let primary = contacts?.filter(x => x.types.newValue.filter(x => x == "Primary"));
        if (primary) {
          if (primary[0] && primary[0].operation && !isNullOrUndefined(primary[0].operation.newValue)) {
            this.primaryPendingForApproval = true;
          }
        }
      }
    })


    combineLatest(
      [this.store.pipe(select(SelectCurrentUser)),
      this.route.parent.params])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([result, params]) => {
        if (params["code"]) {
          this.supplierCode = this.commonService.getSupplierCode(params["code"]);
        }

        if (result) {
          this.userDetails = result;
          let supplierMap: SupplierContactMap = this.userDetails.supplierContact.supplierMaps.find(x => x.supplierCode == this.supplierCode) as SupplierContactMap;
          this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
          this.showMFADialog = showMFADialog(this.authData, result);
        }
        if (this.supplierCode && this.userDetails) {
          this.store.dispatch(new GetTabPermissions(this.supplierCode, true));
          this.store.dispatch(new GetValidationTaskByCode(this.supplierCode));
          this.store.dispatch(new GetSecurityEvent(this.supplierCode));
          this.store.dispatch(new GetSupplierOtpRequestByUser(this.supplierCode));

          this.PrimaryContactDocument(this.store, this.router, this.supplierCode, false);

          this.store.pipe(select(SelectTabPermissions), takeUntil(this.ngUnsubscribe)).subscribe(res => this.tabPermissions = res);
          this.store.pipe(select(SelectValidationTask), takeUntil(this.ngUnsubscribe)).subscribe((result: ValidationTask) => {
            if (result) {
              this.validationTask = result;
              this.isValidationTaskComplete = this.validationTask.statusId === 3;
              this.hasPendingValidationTask = this.validationTask.statusId === 2;
              this.validationStatus = this.validationTask.statusId === 6 ? 'Cancelled' :
                this.validationTask.statusId === 7 ? 'Completed by system' : '';
              if (!this.isValidationTaskComplete) {
                this.primaryEmail = this.validationTask.email;
              }
            }
          });
          this.store.pipe(select(SelectSecurityEventData), takeUntil(this.ngUnsubscribe)).subscribe(event => {
            if (event && event.lastEvent) {
              this.securityBreached = event.lastEvent.status === 'Locked';
            }
          });

          combineLatest(
            [this.store.select(SelectSupplierBankList),
            this.store.select(SelectSupplierDocumentList)])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(([res, documentList]) => {
              if (res && res.length > 0) {
                this.bankInfo = res;
                this.loadGrid();
              }

              if (documentList && documentList.length > 0) {
                this.documentsList = new Array(...documentList);
              }
            });

          this.store.pipe(select(SelectSupplierEntityList), takeUntil(this.ngUnsubscribe)).subscribe(entityMap => {
            this.entityMap = entityMap;
          });

          this.loadComponentData();
        }
      });
    if (this.supplierCode) { 
      this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
    }
  }

  private loadComponentData(isReload: boolean = false): void {
    if (this.supplierCode) {
      if (isReload) {
        this.store.dispatch(new ClearSupplierBanks(this.supplierCode));
      }

      this.store.dispatch(new GetSupplierDocumentsListByCode(this.supplierCode));
      this.store.dispatch(new GetSupplierBankListByCode(this.supplierCode));
      this.store.dispatch(new GetSupplierEntityListByCode(this.supplierCode));

      this.store.pipe(select(SelectSupplierOtpRequest)).subscribe(otpRequest => {
        this.isProfileLocked = otpRequest?.status == "Locked" ? true : false;
      });
    }
  }

  loadGrid() {
    this.total = this.bankInfo.length;

    const skip = this.pageIndex * this.pageSize;
    const take = (this.pageIndex + 1) * this.pageSize;
    this.datasource.next(this.bankInfo.slice(skip, take));
  }

  openPCFDialog() {
    this.showMFANotificationDialog(this.supplierCode, this.supplierContacts, this.dialog);
  }

  onPageChange(pageChange: PageEvent): void {
    const { pageIndex, pageSize } = pageChange;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.loadGrid();
  }

  getDocument(documentId: string) {
    if (this.documentsList && documentId) {
      return this.documentsList.find(doc => getNestedNode(['documentID', 'newValue'], doc) === documentId ||
        getNestedNode(['stageID', 'newValue'], doc) === documentId);
    }
  }

  documentPermission(document: string) {
    let dataItem = this.getDocument(document);

    if (dataItem != null) {
      if (!this.userDetails) {
        return Permission.NoAccess;
      }

      var keys = Object.keys(dataItem);
      return keys.some(key => deepfind(dataItem, `${key}.permission`) === Permission.ReadWrite) === true ? Permission.ReadWrite : Permission.NoAccess;
    }
    return Permission.ReadWrite;
  }

  openBankDialog(selectedBank: SupplierBankPropertyValue): void {
    if(this.showMFADialog){
      this.showMFANotificationDialog(this.supplierCode, this.supplierContacts, this.dialog);
      return;
    }
    const securityCheckdialogRef = this.matDialog.open(SecurityCheckComponent, {
      panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
      width: '45%',
      height: '100%',
      data: {
        supplierCode: this.supplierCode
      }
    });

    securityCheckdialogRef.afterClosed().subscribe((securityAnswers: any) => {
      if (securityAnswers === true) {
        const bankDialogRef = this.matDialog.open(BankDialogComponent, {
          width: '60%',
          maxHeight: '90vh',
          data: {
            data: selectedBank,
            suppliercode: this.supplierCode
          }
        });

        bankDialogRef.afterClosed().subscribe((x: any[]) => {
          if (x && x.length > 0) {
            let newBank: SupplierBankPropertyValue = x[0] as SupplierBankPropertyValue;
            if (selectedBank) {
              newBank.operation.newValue = OPERATION.UPDATE;
            }
            else {
              newBank.operation.newValue = OPERATION.CREATE;
            }

            let docList: SupplierDocumentPropertyValues[];
            if (x.length > 1) {
              docList = x[1] as SupplierDocumentPropertyValues[];
            }

            this.checkDuplicateAndContinue(selectedBank, newBank, docList);
          }
        });
      }
    });
  }

  checkDuplicateAndContinue(selectedBank: SupplierBankPropertyValue, newBank: SupplierBankPropertyValue, docList: SupplierDocumentPropertyValues[]) {
    var existingBanks = this.bankInfo.filter(y => deepfind(y.bankNickName, 'newValue').toLowerCase() == deepfind(newBank.bankNickName, 'newValue').toLowerCase());
    if (selectedBank) {
      existingBanks = existingBanks.filter(y => deepfind(y.bankNickName, 'newValue').toLowerCase() != deepfind(selectedBank.bankNickName, 'newValue').toLowerCase());
    }

    if (existingBanks.length > 0) {
      this.snackBar.open(this.translateService.get('Bank with nickname') + ' "' + deepfind(newBank.bankNickName, 'newValue') + '" ' + this.translateService.get('exists!'), null, {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    } else {
      this.processBankChanges(newBank, docList);
    }
  }

  processBankChanges(newBank: SupplierBankPropertyValue, docList: SupplierDocumentPropertyValues[]) {
    if (newBank) {
      if (docList && docList.length > 0) {
        this.bankModifiedSupplier.documents = [];
        this.bankModifiedSupplier.documents.push(...docList);
      }

      this.bankModifiedSupplier.banks = [];
      this.bankModifiedSupplier.banks.push(newBank);

      this.postEvent(this.bankModifiedSupplier);
    }
  }

  postEvent(eventProperties: SupplierPropertyValue, eventName = 'Bank Change Requested') {
    this.store.dispatch(new ClearEvent());
    this.store.dispatch(new PostEvent({
      Name: eventName,
      Properties: this.pickNewValues(eventProperties),
      ReferenceIdentifier: this.supplierCode
    }));
    this.store.pipe(select(SelectEventData), takeUntil(this.ngUnsubscribe)).subscribe((evt: any) => {
      if (evt) {
        this.loadComponentData(true);
      }
    });
    this.store.pipe(select(SelectErrorMessages), takeUntil(this.ngUnsubscribe)).subscribe((evt: any) => {
      if (evt) {
        this.loadComponentData(true);
      }
    });
  }

  pickNewValues(supplierData: SupplierPropertyValue): Supplier {
    if (!supplierData) {
      return null;
    }
    const supplier = new Supplier();

    if (supplierData.banks) {
      supplier.Banks = [];
      supplierData.banks.forEach((bank, index) => {
        supplier.Banks[index] = new SupplierBank();
        Object.keys(bank).forEach(name => {
          supplier.Banks[index][name] = getNestedNode([name, 'newValue'], bank);
        });
        supplier.Banks[index].Operation = bank.operation.newValue ? bank.operation.newValue : null;
      });
    }

    if (supplierData.documents) {
      supplier.Documents = [];
      supplierData.documents.forEach((document, index) => {
        supplier.Documents[index] = new SupplierDocument();
        Object.keys(document).forEach(name => {
          supplier.Documents[index][name] = getNestedNode([name, 'newValue'], document);
        });
        supplier.Documents[index].Operation = document.operation.newValue ? document.operation.newValue : null;
      });
    }
    return supplier;
  }

  canChangeItem(dataItem: SupplierBankPropertyValue) {
    if (!this.userDetails || this.isPCFValidationInReview) {
      return false;
    }

    let allowChangeItem = false;
    if (dataItem &&
      (!(dataItem.stageID && dataItem.stageID.newValue) || (dataItem.isTouched && (dataItem.stageID && dataItem.stageID.newValue)))) {
      const keys = Object.keys(dataItem);
      allowChangeItem = keys.some(key => deepfind(dataItem, `${key}.permission`) === Permission.ReadWrite);

      // If there is a validation task pending in draft or supplier action pending stage then
      // don't allow edit and delete operation.
      if (allowChangeItem === true && !this.hasWriteAccess) {
        allowChangeItem = false;
      }

      if (allowChangeItem === true && (this.userPendingTasks?.filter(x => x.subTaskType == "MFAEnrollment")?.length > 0)) {
        allowChangeItem = false;
      }
    }

    if (this.hasWriteAccessForValidationTask) {
      allowChangeItem = false;
    }

    return allowChangeItem;
  }

  deleteItem(item: SupplierBankPropertyValue): void {
    if(this.showMFADialog){
      this.showMFANotificationDialog(this.supplierCode, this.supplierContacts, this.dialog);
      return;
    }

    if (this.userDetails == null || this.userDetails.isTeslaUser == true) {
      this.snackBar.open(this.translateService.get("Invalid action."), null, {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
      return;
    }
    if (!item) {
      return;
    }

    const securityCheckdialogRef = this.matDialog.open(SecurityCheckComponent, {
      panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
      width: '45%',
      height: '100%',
      data: {
        supplierCode: this.supplierCode
      }
    });

    securityCheckdialogRef.afterClosed().subscribe((securityAnswers: any) => {
      if (securityAnswers === true) {
        const dialogRef = this.dialog.confirm(this.translateService.get('Confirm'), this.translateService.get('Are you sure you want to delete this bank?'));
        dialogRef.afterClosed().subscribe(x => {
          if (x) {
            if (this.entityMap.findIndex(x => deepfind(x.bankID, 'newValue') &&
              (deepfind(x.bankID, 'newValue') === deepfind(item.id, 'newValue') ||
                deepfind(x.bankID, 'newValue') === deepfind(item.stageID, 'newValue'))) > -1) {
              this.dialog.alert(this.translateService.get('Error'), this.translateService.get('You cannot delete a bank account that is active and in use. Please email the bank account you would like receive payment vendorchanges@tesla.com.'));
            }
            else {
              if (item.id) {
                item.operation.newValue = OPERATION.DELETE;
                // To prefill AccountNumber/IBAN by Event receiver
                item.isNewBankAccount = new PropertyValue<boolean>();
                item.isNewBankAccount.newValue = false;
                let docList = this.documentsList.filter(x => item.documents.newValue.includes(x.documentID.newValue));
                docList.forEach(x => {
                  x.operation.newValue = OPERATION.DELETE;
                });
                this.processBankChanges(item, docList);
              } else {
                this.store.dispatch(new DeleteSupplierBank(this.bankInfo.indexOf(item)));
              }
            }
          }
        });
      }
    });
  }

  get guideLinesUrl(): string {
    return `${this.config.SRM_UI_URL}/documents`;
  }

  showHistory() {
    this.matDialog.open(TabHistoryComponent, {
      width: '90%',
      minWidth: '630px',
      maxHeight: '800px',
      data: { supplierCode: this.supplierCode, tabName: 'Bank' }
    });
  }

  verify(bank: SupplierBankPropertyValue) {
    this.bankService.getVerificationKeys(this.supplierCode)
      .subscribe((response) => {
        var argsAcc = this.bankService.getVerifyArgs(response.signInToken, response.instrumentReference);
        this.payoutRefAngular.verifyAccount(argsAcc)
          .then(res => {
            if (res.decision == 'ACCEPT') {
              setTimeout(function () {
                this.loadComponentData(true);
              }, 5000);
            }
          })
          .catch(ex => {
            console.error(ex);
          })
      });
  }

  navigateToValidationTask() {
    event.preventDefault();
    window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=ContactValidation`);
  }
}
